// Magazine is MediaTracker's single design language. The switchable-skin system
// (calm / fantasy) was dropped — these functions remain so the rest of the app
// keeps a stable import surface, but there is now exactly one skin.
//
// The whole magazine CSS is scoped to `[data-skin="magazine"]` on <html>; an
// inline script in index.html asserts it pre-paint (no FOUC), and
// applySkinOnBoot() re-asserts it at boot.

export const SKINS = ["magazine"];
const SKIN = "magazine";

export function getSkin() {
	return SKIN;
}

// Kept for API compatibility (e.g. any lingering callers); switching is a no-op
// now that magazine is the only skin.
export function setSkin() {
	document.documentElement.dataset.skin = SKIN;
}

export function applySkinOnBoot() {
	document.documentElement.dataset.skin = SKIN;
}
